module.exports = __webpack_public_path__ + "static/media/Q4Mob.c5f18285.png";